/**
 * The gradient sparkle used by the nav-bar "Co-edit" button (orange → indigo),
 * matching the Figma spec. Kept as a dedicated SVG because the tabler icon set is
 * monochrome and can't reproduce the gradient stroke.
 */
export default function CoEditSparkleIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M10.6667 12C11.0203 12 11.3594 12.1405 11.6095 12.3905C11.8595 12.6406 12 12.9797 12 13.3333C12 12.9797 12.1405 12.6406 12.3905 12.3905C12.6406 12.1405 12.9797 12 13.3333 12C12.9797 12 12.6406 11.8595 12.3905 11.6095C12.1405 11.3594 12 11.0203 12 10.6667C12 11.0203 11.8595 11.3594 11.6095 11.6095C11.3594 11.8595 11.0203 12 10.6667 12ZM10.6667 4C11.0203 4 11.3594 4.14048 11.6095 4.39052C11.8595 4.64057 12 4.97971 12 5.33333C12 4.97971 12.1405 4.64057 12.3905 4.39052C12.6406 4.14048 12.9797 4 13.3333 4C12.9797 4 12.6406 3.85952 12.3905 3.60948C12.1405 3.35943 12 3.02029 12 2.66667C12 3.02029 11.8595 3.35943 11.6095 3.60948C11.3594 3.85952 11.0203 4 10.6667 4ZM6 12C6 10.9391 6.42143 9.92172 7.17157 9.17157C7.92172 8.42143 8.93913 8 10 8C8.93913 8 7.92172 7.57857 7.17157 6.82843C6.42143 6.07828 6 5.06087 6 4C6 5.06087 5.57857 6.07828 4.82843 6.82843C4.07828 7.57857 3.06087 8 2 8C3.06087 8 4.07828 8.42143 4.82843 9.17157C5.57857 9.92172 6 10.9391 6 12Z"
        stroke="url(#coedit-sparkle-gradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="coedit-sparkle-gradient"
          x1="2"
          y1="2.66667"
          x2="13.7245"
          y2="5.86557"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{ stopColor: 'var(--co-edit-sparkle-button-start)' }} />
          <stop offset="0.38" style={{ stopColor: 'var(--co-edit-sparkle-button-middle)' }} />
          <stop offset="1" style={{ stopColor: 'var(--co-edit-sparkle-button-end)' }} />
        </linearGradient>
      </defs>
    </svg>
  );
}
